<script setup>
import ReportPage from '../components/ReportPage.vue'
</script>

<template>
  <ReportPage section="cover">
    <div class="cover">
      <div class="cover-top">
        <img class="cover-wm" src="/holo/holo-ink.webp" alt="" aria-hidden="true">
        <div class="cover-brandline"><span class="brand">MIDA</span><span class="brand-sub">Medical × Insurance Data Analytics</span></div>
        <div class="cover-kicker">건강 × 보장 분석 리포트</div>
        <div class="cover-name">{{ customer.name }} 님의<span>건강자산 &amp; 보장분석</span></div>
        <p class="cover-desc">최근 건강검진 결과와 가입한 보험의 보장을 함께 살펴보고,<br>어디가 · 왜 부족한지, 무엇을 먼저 확인할지 정리했습니다.</p>
      </div>

      <div class="cover-main">
        <div class="cover-facts">
          <div><small>연령</small><b>{{ customer.age }}세</b></div>
          <div><small>최근 검진일</small><b>{{ checkupDate || '자료 없음' }}</b></div>
          <div><small>분석한 계약</small><b>{{ contractCount }}건</b></div>
          <div><small>작성일</small><b>{{ reportDate }}</b></div>
        </div>

        <div class="cover-three">
          <h2>이 리포트에서 먼저 볼 세 가지</h2>
<ol><li><span class="num st-follow-bg">1</span><div><b>건강 상태</b><p>최근 건강검진 기록의 검사값과 원문 소견을 함께 확인합니다.</p></div></li><li><span class="num lack-bg">2</span><div><b>보장 자산</b><p>가입한 보험의 보장 내용과 권장금액을 같은 비교 기준으로 정리합니다.</p></div></li><li><span class="num ok-bg">3</span><div><b>관리 방향</b><p>건강과 보장에서 앞으로 함께 확인할 사항을 살펴봅니다.</p></div></li></ol>
        </div>

<div class="cover-toc"><span>차례</span><ol><li><b>01</b>최근 건강검진</li><li><b>02</b>몸의 위치로 보기</li><li><b>03</b>주요 검사값</li><li><b>04</b>보유 보험 보장</li><li><b>05</b>질환별 건강과 보장</li><li><b>06</b>계약별 보장내용</li><li><b>07</b>함께 확인할 보장</li><li><b>08</b>검진 항목 전체</li><li><b>09</b>계산 기준과 출처</li></ol></div>
      </div>

      <div class="cover-foot">
        <div>작성일 {{ reportDate }} · 이 리포트는 참고 자료이며 진단, 보험 가입 권유, 보험금 지급 확약이 아닙니다.</div>
        <div class="basis">분석 기준: 제공된 건강검진 자료 · 보험 보장분석 자료 ({{ reportDate }} 기준)</div>
      </div>
    </div>
  </ReportPage>
</template>

<script>
export default {
  props: {
    customer: { type: Object, required: true },
    reportDate: { type: String, required: true },
    checkupDate: { type: String, default: null },
    contractCount: { type: Number, default: 0 }
  }
}
</script>
